import { z } from 'zod/v4'

const dimensionSchema = z.object({
  label: z.string().optional(),
  value: z.coerce.number().nonnegative({ message: 'Priority must be at least 0' }),
});

export const summaryProductValidation = () => {
  return z.object({
    sku: z.string().min(1, { message: 'Form is required' }),
    ali_sku: z.string().min(1, { message: 'Form is required' }),
    title: z.string().min(3, { message: 'Title must be at least 3 characters' }),
    slug: z.string().min(1, { message: 'Form is required' }),
    description: z.string().optional().or(z.literal('')),
    visibility: z.string(),
    not_show_in_catalog: z.string(),
    status: z.string().min(1, { message: 'Form is required' }),
    export_only: z.boolean(),
    priority: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    supplier_id: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    brand_id: z.string().nullable(),
    warehouses: z.string().nullable(),
    country_id: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    province_id: z.string().nullable(),
    city_id: z.string().nullable(),
    district_id: z.string().nullable(),
    original_currency: z.string().min(1, { message: 'Form is required' }),
    regular_price: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    sale_price: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    reseller_price: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    markup_percentage: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    reward_point: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    base_qty_review: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    base_average_review_point: z.coerce.number().nonnegative({ message: 'Form is required' }),
    base_qty_sold: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    group_qty: z.coerce.number().nonnegative({ message: 'Priority must be at least 0' }).nullable().optional(),
    quantity: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    minimum_qty: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    quantity_unit: z.string().min(1, { message: 'Form is required' }),
    weight: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    weight_unit: z.string().min(1, { message: 'Form is required' }),
    qty_per_cbm: z.number().nonnegative({ message: 'Priority must be at least 0' }),
    tags: z.array(z.string()),
    po_ship_from: z.string().nullable().optional(),
    po_shipment_method: z.string().nullable().optional(),
    dimension_unit: z.string().min(1, { message: 'Form is required' }),
    dimensions: z.array(dimensionSchema).min(1, { message: 'Form is required' }),
    categories: z.array(z.string().min(1, { message: 'Form is required' })).min(3, { message: 'Category must be set to level 3' }),
  }).refine(
    (data) => {
      if (data.tags.includes('10')) {
        return data.po_ship_from !== null
      }
      return true
    }, {
      message: 'Form is required',
      path: ['po_ship_from']
    }
  ).refine(
    (data) => {
      if (data.tags.includes('10')) {
        return data.po_shipment_method !== null
      }
      return true
    }, {
      message: 'Form is required',
      path: ['po_shipment_method']
    }
  )
}